module.exports = __webpack_public_path__ + "img/loading.3b4b0b98.webp";